<script lang="ts">
      import { urlFromSlug } from "$lib/utils/payload/relations"

      let { item = null, class: className = '', onclick } = $props()

      let url = $derived.by( () => {
        //if(item.type == "internal") return urlFromSlug(item.slug)
        if(item.type == "internal") return item.slug
        return item.link
      })

</script>

{#if item}
      <a href="{url}" {onclick} class="flex items-center text-right uppercase {className}">
            {item.label}
      </a>
{/if}
